export default __webpack_public_path__ + "static/media/team110.992cedd9.JPG";